/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import '../css/Footer.css';

class Footer extends Component {
    static propTypes = {
        locale: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {selectedIndex: 0};
    }

    select = (index) => this.setState({selectedIndex: index});

    render() {
        return (
            <Fragment>
                <div className="footer-powered footer-font"
                     style={{backgroundColor: '#00002b'}}
                >
                    <div className="privacy-company footer-margin"
                         style={{color: this.props.theme.objectTheme.palette.borderColor}}
                    >© 2018 Gek Srl</div>
                    <a className="privacy-text footer-margin link-default"
                       style={{color: this.props.theme.objectTheme.palette.borderColor}}
                       href="/"
                    >{this.props.locale.terms}</a>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.locale.locale,
    theme: state.theme,
});

export default connect(
    mapStateToProps,
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js